import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getHistory = async (panelListId, page) => {
  return secureGet("/api/survey/getSurveyHistory", { panelListId, page });
};
